import { ISaveExpenseType } from '../../shared';

export const expenseTypeFromFormMapper = (expenseType: ISaveExpenseType): ISaveExpenseType => {
    return {
        ...expenseType,
        baseLumpSum: expenseType.lumpSum ? expenseType.baseLumpSum : 0,
        lumpSums: expenseType.lumpSum ? expenseType.lumpSums : [],
    };
};
